import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { CaskSubLocation } from "@/app/services/generated/casklocationService";
import { caskLocationService } from "@/app/services/generated/casklocationService";

// Singleton cache store
const caskSubLocationsCacheStore = new EntityCacheStore<CaskSubLocation>(
  EnumCacheEntityType.caskSubLocation,
  async () => caskLocationService.getAllCaskSubLocations()
);

// Ephemeral reader
export default class CaskSubLocationsCache extends EntityWithGuidKeyCache<CaskSubLocation> {
  constructor() {
    super(caskSubLocationsCacheStore, (x) => x.id);
  }
}
